module.exports = __webpack_public_path__ + "static/media/eye-crossed.19db5c95.png";